import { render, staticRenderFns } from "./NaverShoppingConfigIframe.vue?vue&type=template&id=6e503ca7&"
import script from "./NaverShoppingConfigIframe.vue?vue&type=script&lang=ts&"
export * from "./NaverShoppingConfigIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports